import * as React from 'react'
import { Button, ButtonGroup, Form } from 'react-bootstrap'


import { AxiosInstance } from '../../utils/RequestMethods'
import config from '../../constants/config'
import { VariablesObj, VariablesT, CompanyT } from '../../types/Company'
import { copyObject } from '../../utils'
import NumberFormatValidate from '../../components/NumberFormatValidate'

import * as _ from 'lodash'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
interface RatesTabProps {
    company: CompanyT,
    updateCompany(company: CompanyT): void
}


const RatesTab: React.FunctionComponent<RatesTabProps> = ({ company, updateCompany }): JSX.Element => {
    const [variables, setVariables] = React.useState(VariablesObj)
    const [dirtyVariables, setDirtyVariables] = React.useState(null)
    const [isReady, setIsReady] = React.useState(false)
    let refBtnSave = React.useRef(null)

    React.useEffect(() => {
        setIsReady(true)
    }, []);

    React.useEffect((): void => {
        if (company && company.variables) {
            setVariables({ ...VariablesObj, ...company.variables })
        }
    }, [company])


    /**
     *
     * @returns
     */
    const companyUpdateRates = async (): Promise<string> => {

        const paramsVariables = {}
        Object.keys(variables).map((key) => {
            paramsVariables[key] = variables[key]
        })

        const params = {
            "variables": paramsVariables,
        }
        return AxiosInstance.post(`${config.url.companies}/${company.id}`, params).then((res) => {

            if (res && (res.status || res.status == 200)) {
                let msg = 'Settings saved.'

                if (res.data) {
                    updateCompany(res.data)
                }
                return msg
            } else {
                let msg = 'Settings save failed.'
                throw new Error(msg);

            }
        }).catch((error) => {
            throw new Error(error);

        })
    }

    const onChangeVariables = (key: string, value: any, subKey: 'value' | 'rateLabel' | 'unitsLabel' | 'verboseName' = 'value') => {
        if (!isReady) {
            return false;
        }
        let variablesClone = copyObject(variables)
        variablesClone[key][`${subKey}`] = value;
        // setVariables(variablesClone)
        setVariables(calculatingVariables(variablesClone, key, value))
    }

    const calculatingVariables = (_variables: VariablesT, key: string, value: any) => {
        let tempVariables = copyObject(_variables)
        // ^[a-zA-Z]+(Local|Long)$
        // find in key for Long|Local
        const regex = /(Long|Local)$/g;


        let match = key.match(regex) || []
        if (match.length <= 0) {
            return _variables;
        }
        // groupName: 'Local' | 'Long'
        const groupName = match[0]
        let keysRequired = ['deposit', 'beforePickup', 'beforeDelivery']

        if ((groupName == 'Local' && _variables.depositLocal.unitsLabel == "$") || (groupName == "Long" && _variables.depositLong.unitsLabel == "$")) {
            keysRequired = ['beforePickup', 'beforeDelivery']
        }

        /**
         * loop keysRequired  and add type local|long end name key
         */
        const fixedKeysRequired = keysRequired.map((item, index) => {
            return `${item}${groupName}`
        })

        const updateVariable = (_variables, _key, _value): VariablesT => {
            let cloneVariables = copyObject(_variables)
            cloneVariables[_key].value = _value
            return cloneVariables
        }


        let sumTotal = 0
        let afterDelivery = 0;
        Object.keys(_variables).map((_key, index) => {
            if (fixedKeysRequired.includes(_key)) {
                sumTotal += parseFloat(`${Number(_variables[_key].value)}`)
            }
        })

        if (sumTotal < 0) {
            sumTotal = 0
        }

        if (sumTotal < 100) {
            afterDelivery = 100 - parseFloat(`${sumTotal}`)
        } else if (sumTotal > 100) {
            let totalValues = 0
            // calc total correct values
            Object.keys(_variables).map((_key, index) => {
                if (fixedKeysRequired.includes(_key) && key != _key) {
                    totalValues += parseFloat(`${_variables[_key].value}`)
                }
            })
            let resetValue = 100 - parseFloat(`${totalValues}`)
            tempVariables = updateVariable(tempVariables, key, resetValue)
            afterDelivery = 0
        } else {
            afterDelivery = 0
        }

        tempVariables = updateVariable(tempVariables, `afterDelivery${groupName}`, afterDelivery)
        return tempVariables;

    }

    const validatePercent = (value: number): number => {
        if (value == undefined || isNaN(value)) {
            return 0;
        }
        if (parseFloat(`${value}`) > 100) {
            return 100
        } else if (parseFloat(`${value}`) < 0) {
            return 0
        }
        return value
    }

    return (
        <div>
            <h3>Labor / Local</h3>
            <Form.Label>Crew of 1 - Moving Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateOne.value}`}
                value={`${variables.hourlyRateOne.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateOne', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>Crew of 2 - Moving Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateTwo.value}`}
                value={`${variables.hourlyRateTwo.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateTwo', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>Crew of 3 - Moving Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateThree.value}`}
                value={`${variables.hourlyRateThree.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateThree', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />

            <Form.Label>Crew of 4 - Moving Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateFour.value}`}
                value={`${variables.hourlyRateFour.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateFour', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />

            <Form.Label>Crew of 1 - Packing Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateOnePacking.value}`}
                value={`${variables.hourlyRateOnePacking.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateOnePacking', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>Crew of 2 - Packing Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateTwoPacking.value}`}
                value={`${variables.hourlyRateTwoPacking.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateTwoPacking', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>Crew of 3 - Packing Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateThreePacking.value}`}
                value={`${variables.hourlyRateThreePacking.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateThreePacking', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />

            <Form.Label>Crew of 4 - Packing Labor, $/hr</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.hourlyRateFourPacking.value}`}
                value={`${variables.hourlyRateFourPacking.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('hourlyRateFourPacking', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>Estimate, $</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.estimate.value}`}
                value={`${variables.estimate.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('estimate', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                prefix={'$'}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>Deposit</Form.Label>
            &nbsp;
            <ButtonGroup aria-label="Basic example">
                <Button variant={`${variables.depositLocal.unitsLabel}` == "$" ? 'secondary' : 'light'}
                    onClick={() => {
                        onChangeVariables('depositLocal', '$', 'unitsLabel')
                    }}>$</Button>
                <Button variant={`${variables.depositLocal.unitsLabel}` == "%" ? 'secondary' : 'light'}
                    onClick={() => {
                        onChangeVariables('depositLocal', '%', 'unitsLabel')
                    }}>%</Button>
            </ButtonGroup>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.depositLocal.value}`}
                value={`${variables.depositLocal.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('depositLocal', variables.depositLocal.unitsLabel == '%' ? validatePercent(floatValue) : floatValue)
                }}
                mask="_"
                thousandSeparator={variables.depositLocal.unitsLabel == '$'}
                prefix={variables.depositLocal.unitsLabel == '$' ? '$' : ''}
                suffix={variables.depositLocal.unitsLabel == '%' ? '%' : ''}
                fixedDecimalScale={variables.depositLocal.unitsLabel == '$'}
                decimalScale={2}
            />
            <Form.Label>Before Pick-up, %</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={`${variables.beforePickupLocal.value}`}
                value={`${variables.beforePickupLocal.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables("beforePickupLocal", validatePercent(floatValue))
                }}
                isAllowed={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    return parseInt(value) >= 0 || parseInt(value) <= 100
                }}
                placeholder=""
                mask="_"
                suffix="%" />

            <Form.Label>Before Delivery, %</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={`${variables.beforeDeliveryLocal.value}`}
                value={`${variables.beforeDeliveryLocal.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables("beforeDeliveryLocal", validatePercent(floatValue))
                }}
                isAllowed={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    return parseInt(value) >= 0 || parseInt(value) <= 100
                }}
                placeholder=""
                mask="_"
                suffix="%" />

            <Form.Label>After Delivery, %</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={`${variables.afterDeliveryLocal.value}`}
                value={`${variables.afterDeliveryLocal.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    // onChangeVariables("afterDeliveryLocal", validatePercent(floatValue))
                }}
                isAllowed={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    return floatValue >= 0 || floatValue <= 100
                }}
                disabled
                placeholder=""
                mask="_"
                suffix="%" />

            <Form.Label>Minimum Time, hrs</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.minimumTime.value}`}
                value={`${variables.minimumTime.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('minimumTime', floatValue)
                }}
                decimalScale={2}
                mask="_" />
            <Form.Label>Default Worker Variable Pay, $/hour</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.workerPay.value}`}
                value={`${variables.workerPay.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('workerPay', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2} />
            {/* SYSTEM DEFAULT FOR WORKER FLAT PAY SHOULD BE $150.00*/}
            <Form.Label>Default Worker Flat Pay, $</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.workerFlatPay.value}`}
                value={`${variables.workerFlatPay.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('workerFlatPay', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2} />
            <h3>Long-distance / Interstate / International Moving</h3>
            <Form.Label>Weight Rate, $/lb</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.moving.value}`}
                value={`${variables.moving.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('moving', floatValue)
                }}
                mask="_" />
            <Form.Label>Volume to Weight Converstion, lb/cuft</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.movingVolToWeightConversion.value}`}
                value={`${variables.movingVolToWeightConversion.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('movingVolToWeightConversion', floatValue)
                }}
                mask="_" />
            <Form.Label>Long Carry Unit Distance, ft</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.longCarryUnitDistance.value}`}
                value={`${variables.longCarryUnitDistance.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('longCarryUnitDistance', floatValue)
                }}
                mask="_" />
            <Form.Label>Long Carry, $/ft</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.longCarryRate.value}`}
                value={`${variables.longCarryRate.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('longCarryRate', floatValue)
                }}
                mask="_" />
            <Form.Label>Deposit</Form.Label>
            &nbsp;
            <ButtonGroup aria-label="Basic example">
                <Button variant={variables.depositLong.unitsLabel == "$" ? 'secondary' : 'light'}
                    onClick={() => {
                        onChangeVariables('depositLong', '$', 'unitsLabel')
                    }}>$</Button>
                <Button variant={variables.depositLong.unitsLabel == "%" ? 'secondary' : 'light'}
                    onClick={() => {
                        onChangeVariables('depositLong', '%', 'unitsLabel')
                    }}>%</Button>
            </ButtonGroup>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.depositLong.value}`}
                value={`${variables.depositLong.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('depositLong', variables.depositLong.unitsLabel == '%' ? validatePercent(floatValue) : floatValue)
                }}
                mask="_"
                thousandSeparator={variables.depositLong.unitsLabel == '$'}
                prefix={variables.depositLong.unitsLabel == '$' ? '$' : ''}
                suffix={variables.depositLong.unitsLabel == '%' ? '%' : ''}
                fixedDecimalScale={variables.depositLong.unitsLabel == '$'}
                decimalScale={2}
            />
            <Form.Label>Before Pick-up, %</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={`${variables.beforePickupLong.value}`}
                value={`${variables.beforePickupLong.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables("beforePickupLong", validatePercent(floatValue))
                }}
                isAllowed={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    return parseInt(value) >= 0 || parseInt(value) <= 100
                }}
                placeholder=""
                // format="###-##-####"
                mask="_"
                suffix="%" />

            <Form.Label>Before Delivery, %</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={`${variables.beforeDeliveryLong.value}`}
                value={`${variables.beforeDeliveryLong.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables("beforeDeliveryLong", validatePercent(floatValue))
                }}
                isAllowed={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    return parseInt(value) >= 0 || parseInt(value) <= 100
                }}
                placeholder=""
                mask="_"
                suffix="%" />

            <Form.Label>After Delivery, %</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={`${variables.afterDeliveryLong.value}`}
                value={`${variables.afterDeliveryLong.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    // onChangeVariables("afterDeliveryLong", validatePercent(floatValue))
                }}
                isAllowed={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    return parseInt(value) >= 0 || parseInt(value) <= 100
                }}
                disabled
                placeholder=""
                mask="_"
                suffix="%" />

            <Form.Label>{variables.localIntrastateMargin.verboseName}, mile</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.localIntrastateMargin.value}`}
                value={`${variables.localIntrastateMargin.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('localIntrastateMargin', floatValue)
                }}
                mask="_" />

            <Form.Label>{variables.changeCrewSizeFee.verboseName}, $</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.changeCrewSizeFee.value}`}
                value={`${variables.changeCrewSizeFee.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('changeCrewSizeFee', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2} />
            <Form.Label>{variables.changeDatetimeFee.verboseName}, $</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${variables.changeDatetimeFee.value}`}
                value={`${variables.changeDatetimeFee.value}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    onChangeVariables('changeDatetimeFee', floatValue)
                }}
                mask="_"
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2} />
                 <Form.Label>Booking Fee, $</Form.Label>
                <NumberFormatValidate
                 customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${variables.bookingFee.value}`}
                    value={`${variables.bookingFee.value}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        onChangeVariables('bookingFee', floatValue)
                    }}
                    mask="_"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                    decimalScale={2} />
            {/* <Form.Control className='input-material' disabled /> */}
            <ButtonLoading
                onClickFetching={companyUpdateRates}
                type="submit"

                className="btn-success">Save</ButtonLoading>

        </div>
    )
}

export default RatesTab
